import React from "react";
import { connect } from '../../store/connect';
import { API_METHODS_ENUM } from "../../httpService";
import { LoaderState } from "../../store/actions/loader.actions";
import { Loader } from "./Loader";
import { Overlay } from "./Overlay";
import has from "lodash/has";
var overlayLoaderFactory = function () {
    var OverlayLoader = function (_a) {
        var _b = _a.show, show = _b === void 0 ? false : _b, children = _a.children;
        return (React.createElement(React.Fragment, null,
            children,
            show &&
                React.createElement(Overlay, { className: "ws-overlay-loader" },
                    React.createElement(Loader, null))));
    };
    var mapStateToProps = function (state, ownProps) {
        var loaderState = new LoaderState(state.loaderReducer, {
            keys: [
                API_METHODS_ENUM.POST_BOOKING_FORM,
                API_METHODS_ENUM.POST_PAYBOOK_FORM,
                API_METHODS_ENUM.POST_USER_CONSENTS,
                API_METHODS_ENUM.POST_SEPA_FORM,
                API_METHODS_ENUM.POST_CANCEL_BOOKING_FORM,
                API_METHODS_ENUM.GET_OUTGOING_MESSAGES,
            ]
        });
        return {
            show: has(ownProps, "show") ? ownProps.show : loaderState.isLoading()
        };
    };
    return connect(mapStateToProps)(OverlayLoader);
};
export var OverlayLoader = overlayLoaderFactory();
